import { DEFAULT_CURRENCY } from "@/data/constants";
import { toMajorUnits } from "@/utils/toMajorUnits";
import { EstimateIntervalData } from "@/components/shared/interval-switch/estimate-interval-change";
import { InvoiceHistoryItem } from "../handlers/getInvoiceHistory";
import { TLedgerAmounts } from "../types.dashboard";
import { toSwitchTodayAmounts } from "./toSwitchTodayAmounts";

const MONTHS_PER_YEAR = 12;

/** Maps the yearly-switch estimate and paid monthly run to ledger amounts (minor → major units). */
export function toLedgerAmounts(
  estimate: EstimateIntervalData,
  paidRun: InvoiceHistoryItem[],
): TLedgerAmounts {
  const currency = estimate.currency ?? DEFAULT_CURRENCY;
  const toMajor = (amount = 0) => toMajorUnits(amount, currency);
  const [latestRenewal] = paidRun;
  const monthsPaid = paidRun.length;

  const monthlyMinor = latestRenewal
    ? latestRenewal.amount - latestRenewal.discount_amount
    : 0;
  // Summed per invoice: coupons and price changes vary the charge month to month
  const paidSoFarMinor = paidRun.reduce(
    (sum, invoice) => sum + invoice.amount - invoice.discount_amount,
    0,
  );
  const yearlyMinor = estimate.plan_amount ?? 0;
  const yearlyAsMonthlyMinor = Math.round(yearlyMinor / MONTHS_PER_YEAR);

  return {
    currency,
    monthlyPrice: toMajor(monthlyMinor),
    monthsPaid,
    paidSoFar: toMajor(paidSoFarMinor),
    yearlyAsMonthly: toMajor(yearlyAsMonthlyMinor),
    savedSoFar: toMajor(paidSoFarMinor - yearlyAsMonthlyMinor * monthsPaid),
    savedPerYear: toMajor(monthlyMinor * MONTHS_PER_YEAR - yearlyMinor),
    yearlyPrice: toMajor(yearlyMinor),
    ...toSwitchTodayAmounts(estimate),
  };
}
